import React, { FC, SVGProps } from 'react';

/** @deprecated use <Icon name="..." /> (import from @/components/primitives/icons/Icon) instead. */
const SvgComponent: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.375 6.90625H13.875C13.9438 6.90625 14 6.85 14 6.78125V5.90625C14 5.8375 13.9438 5.78125 13.875 5.78125H6.375C6.30625 5.78125 6.25 5.8375 6.25 5.90625V6.78125C6.25 6.85 6.30625 6.90625 6.375 6.90625ZM6.25 10.0938C6.25 10.1625 6.30625 10.2188 6.375 10.2188H13.875C13.9438 10.2188 14 10.1625 14 10.0938V9.21875C14 9.15 13.9438 9.09375 13.875 9.09375H6.375C6.30625 9.09375 6.25 9.15 6.25 9.21875V10.0938ZM14.125 2.5H1.875C1.80625 2.5 1.75 2.55625 1.75 2.625V3.5C1.75 3.56875 1.80625 3.625 1.875 3.625H14.125C14.1938 3.625 14.25 3.56875 14.25 3.5V2.625C14.25 2.55625 14.1938 2.5 14.125 2.5ZM14.125 12.375H1.875C1.80625 12.375 1.75 12.4312 1.75 12.5V13.375C1.75 13.4438 1.80625 13.5 1.875 13.5H14.125C14.1938 13.5 14.25 13.4438 14.25 13.375V12.5C14.25 12.4312 14.1938 12.375 14.125 12.375ZM2.225 10.0328L4.66719 8.10938C4.68363 8.09645 4.69692 8.07996 4.70606 8.06115C4.71521 8.04234 4.71995 8.0217 4.71995 8.00078C4.71995 7.97987 4.71521 7.95922 4.70606 7.94041C4.69692 7.9216 4.68363 7.90511 4.66719 7.89219L2.225 5.96719C2.13437 5.89531 2 5.95937 2 6.075V9.92344C1.99999 9.94953 2.00733 9.97511 2.02117 9.99723C2.03501 10.0194 2.05479 10.0371 2.07827 10.0486C2.10174 10.06 2.12794 10.0645 2.15389 10.0618C2.17984 10.059 2.20448 10.0489 2.225 10.0328Z"
        fill="currentColor"
        fillOpacity="0.88"
      />
    </svg>
  );
};

export default SvgComponent;
